export const environment = {
  production: true,
  apiUrl: "https://staging-api.jidvei.ro",
  clubUrl: "https://staging-club.jidvei.ro",
  staffUrl: "https://staging-staff.jidvei.ro",
  sentryDsnClub: "",
  sentryEnvironment: "staging",
};
